import React, { useState } from "react";
import { Outlet, useOutletContext } from "react-router";

const DistributeTo = () => {
  const [selectedUserGroup, setSelectedUserGroup] = useState([]);
  const { tenantName, loading, setLoading } = useOutletContext();

  return (
    <Outlet
      context={{
        selectedUserGroup,
        setSelectedUserGroup,
        tenantName,
        loading,
        setLoading,
      }}
    />
  );
};

export default DistributeTo;
